import { blue3, grey7, tannBlue } from 'utils/theme/colors'
import { CheckboxProps } from '../../utils/core.types'

export const styleForCheckbox = (
    checked: boolean | undefined,
    required: boolean | undefined,
    disabled: boolean | undefined,
    isHighlighted: boolean | undefined
): Partial<CheckboxProps> => {
    const common = {
        disabled: disabled || false,
        isHighlighted: isHighlighted || false,
    }

    if (disabled && required) {
        return {
            checkMarkColor: getSvgColor(tannBlue),
            borderColor: getSvgColor(blue3),
            ...common,
        }
    }

    if (disabled) {
        return {
            checkMarkColor: getSvgColor(tannBlue),
            borderColor: getSvgColor(grey7),
            ...common,
        }
    }

    if (required) {
        return {
            checkMarkColor: getSvgColor(tannBlue),
            borderColor: getSvgColor(blue3),
            ...common,
        }
    }

    return {
        checkMarkColor: getSvgColor(tannBlue),
        borderColor: getSvgColor(grey7),
        ...common,
    }
}

const getSvgColor = (color: string) => {
    return color.replaceAll('#', '%23')
}
